const REGISTER_TYPE = 0;
const LOGIN_TYPE = 1;
const SEARCH_TYPE = 2;
const SEARCH_CATEGORY_FOR_PRODUCT = 3;
const REGISTER_EMAIL_FOCUS_TYPE = 4;
const REGISTER_EMAIL_BLUR_TYPE = 5;
const ERROR_TYPE = 6;
const ERROR_TYPE_PROMISE = 7;
const INIT_CREATE_COMPANY_TYPE = 8;

export { REGISTER_TYPE, LOGIN_TYPE, SEARCH_TYPE, SEARCH_CATEGORY_FOR_PRODUCT, 
    REGISTER_EMAIL_FOCUS_TYPE, REGISTER_EMAIL_BLUR_TYPE, ERROR_TYPE, ERROR_TYPE_PROMISE,
    INIT_CREATE_COMPANY_TYPE };